<div class="container mx-auto p-6">
  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center h-64">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
  </div>

  <!-- Contenido del banco -->
  <div *ngIf="!loading && bank" class="space-y-6 animate-fade-in">

    <!-- Header: Nombre del banco + botones -->
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div class="flex items-center gap-4">
          <div class="w-14 h-14 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center shadow-lg">
            <svg class="w-7 h-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
            </svg>
          </div>
          <div>
            <h2 class="text-2xl font-bold text-gray-800">{{ bank.name }}</h2>
            <p class="text-sm text-gray-500 mt-0.5">{{ bank.account_number }}</p>
          </div>
          <!-- Badge Estado -->
          <div>
            <span *ngIf="bank.active" class="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-green-100 text-green-800">
              <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
              </svg>
              Activo
            </span>
            <span *ngIf="!bank.active" class="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-gray-100 text-gray-800">
              <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
              </svg>
              Inactivo
            </span>
          </div>
        </div>
        <div class="flex gap-2 self-start sm:self-center">
          <!-- Botón Volver -->
          <button
            [routerLink]="['/dashboard/administracion']"
            [queryParams]="{entity: 'banks'}"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200">
            Volver a Bancos
          </button>
        </div>
      </div>
    </div>

    <!-- Modo Edición: formulario inline -->
    <div *ngIf="editMode" class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h3 class="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
        <svg class="w-5 h-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
        Editar Banco
      </h3>
      <app-generic-form
        [genericForm]="editForm"
        [selectedItem]="bank"
        [showCancel]="true"
        (onCancel)="toggleEditMode()"
        (onFinished)="onEditFinished($event)">
      </app-generic-form>
    </div>

    <!-- Modo Visualización -->
    <div *ngIf="!editMode">
      <!-- Grid principal -->
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">

        <!-- Columna izquierda: Información del banco (2/3) -->
        <div class="lg:col-span-2 space-y-6">

          <!-- Información general -->
          <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div class="flex justify-between items-center mb-4">
              <h3 class="text-lg font-semibold text-gray-800 flex items-center gap-2">
                <svg class="w-5 h-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Información General
              </h3>
              <button *ngIf="!editMode" (click)="toggleEditMode()"
                class="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-primary border border-primary rounded-lg hover:bg-primary hover:text-white transition-colors duration-200">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                Editar
              </button>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <span class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Nombre del Banco</span>
                <p class="text-sm font-medium" [ngClass]="bank.name ? 'text-gray-900' : 'text-gray-400 italic'">{{ bank.name || '—' }}</p>
              </div>
              <div>
                <span class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Código</span>
                <p class="text-sm" [ngClass]="bank.code ? 'text-gray-900' : 'text-gray-400 italic'">{{ bank.code || '—' }}</p>
              </div>
              <div>
                <span class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Número de Cuenta</span>
                <p class="text-sm font-mono" [ngClass]="bank.account_number ? 'text-gray-900' : 'text-gray-400 italic'">{{ bank.account_number || '—' }}</p>
              </div>
              <div>
                <span class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Titular</span>
                <p class="text-sm" [ngClass]="bank.account_holder ? 'text-gray-900' : 'text-gray-400 italic'">{{ bank.account_holder || '—' }}</p>
              </div>
            </div>
          </div>

          <!-- Timestamps -->
          <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h3 class="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <svg class="w-5 h-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Historial
            </h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <span class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Fecha de Creación</span>
                <p class="text-sm text-gray-900">{{ bank.created_at | date:'dd/MM/yyyy HH:mm' }}</p>
              </div>
              <div *ngIf="bank.updated_at">
                <span class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Última Modificación</span>
                <p class="text-sm text-gray-900">{{ bank.updated_at | date:'dd/MM/yyyy HH:mm' }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Columna derecha: Saldos (1/3) -->
        <div class="space-y-6">
          <!-- Saldo inicial -->
          <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6 sticky top-24">
            <h3 class="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <svg class="w-5 h-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Saldo Inicial
            </h3>

            <div class="bg-gradient-to-br from-green-50 to-emerald-50 rounded-lg p-4 border border-green-200">
              <div class="flex items-center justify-between">
                <span class="text-sm font-medium text-green-700">Balance Inicial</span>
                <svg class="w-5 h-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <p class="text-3xl font-bold text-green-900 mt-2">
                {{ formatCurrency(bank.initial_balance || 0) }}
              </p>
            </div>

            <!-- Saldo actual (si existe) -->
            <div *ngIf="bank.current_balance !== undefined" class="mt-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-4 border border-blue-200">
              <div class="flex items-center justify-between">
                <span class="text-sm font-medium text-blue-700">Saldo Actual</span>
                <svg class="w-5 h-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <p class="text-3xl font-bold text-blue-900 mt-2">
                {{ formatCurrency(bank.current_balance) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Estado vacío -->
  <div *ngIf="!loading && !bank" class="text-center py-16">
    <svg class="mx-auto h-16 w-16 text-gray-300 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
    </svg>
    <p class="text-gray-500 text-lg font-medium">Banco no encontrado</p>
    <p class="text-gray-400 text-sm mt-1">El banco solicitado no existe o no tienes acceso</p>
    <button
      [routerLink]="['/dashboard/administracion']"
      [queryParams]="{entity: 'banks'}"
      class="mt-4 px-4 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary-dark transition-colors duration-200">
      Volver a Bancos
    </button>
  </div>
</div>
